<template>
  <div>
    <div
      class="row small-collapse"
      :class="{ 'formValidation-shake': isShake }"
    >
      <h2>{{ title }}</h2>
      <p>{{ intro }}</p>

      <div class="small-6 columns left-field">
        <label for="firstName">
          First name
          <input
            type="text"
            name="firstName"
            id="firstName"
            v-model="firstName"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('firstName') }"
            data-vv-as="first name"
          />
          <span class="form-error-area" v-if="errors.first('firstName')">
            <p>{{ errors.first("firstName") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 columns right-field">
        <label for="lastName">
          Last name
          <input
            type="text"
            name="lastName"
            id="lastName"
            v-model="lastName"
            v-validate="'required'"
            :class="{ 'border-red': errors.has('lastName') }"
            data-vv-as="last name"
          />
          <span class="form-error-area" v-if="errors.first('lastName')">
            <p>{{ errors.first("lastName") }}</p>
          </span>
        </label>
      </div>
      <div class="small-12 left-field columns">
        <label for="email">
          Email
          <input
            type="email"
            name="email"
            id="email"
            v-model="email"
            v-validate="'required|email'"
            :class="{ 'border-red': errors.has('email') }"
            data-vv-as="email"
          />
          <span class="form-error-area" v-if="errors.first('email')">
            <p>{{ errors.first("email") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 left-field columns">
        <label for="phone">
          Phone
          <input
            type="tel"
            name="phone"
            id="phone"
            v-validate="'numeric'"
            v-model="phone"
            :class="{ 'border-red': errors.has('phone') }"
            data-vv-as="phone"
          />
          <span class="form-error-area" v-if="errors.first('phone')">
            <p>{{ errors.first("phone") }}</p>
          </span>
        </label>
      </div>
      <div class="small-6 right-field columns">
        <label for="postcode">
          Postcode
          <input
            type="tel"
            name="postcode"
            id="postcode"
            v-validate="'required|numeric'"
            v-model="postCode"
            :class="{ 'border-red': errors.has('postcode') }"
            data-vv-as="postcode"
          />
          <span class="form-error-area" v-if="errors.first('postcode')">
            <p>{{ errors.first("postcode") }}</p>
          </span>
        </label>
      </div>
      <div class="optin-area">
        <div>
          <span class="checkbox">
            <input
              type="checkbox"
              id="optinIntrepidTravel"
              name="optinIntrepidTravel"
              value="IntrepidTravel"
              v-model="optIns"
            />
            <label class="control-label" for="optinIntrepidTravel"
              >Yes! Sign me up to the Intrepid newsletter to receive exclusive
              offers, travel inspiration &amp; more!</label
            >
          </span>
        </div>
      </div>
      <div class="clear">
        <div class="submit-bttn bttn-lrg">
          <input type="button" :value="buttontitle" v-on:click="save" />
        </div>
      </div>
    </div>
    <div class="privacy-statement">
      <p>
        By signing you accept
        <a href="/privacy-policy/privacy-policy" target="_blank"
          >WWF-Australia’s Privacy Policy.</a
        ><br />
        <a :href="termsandconditionurl" target="_blank"
          >View terms &amp; conditions</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "EarthhourCompetition",
  props: {
    title: {
      type: String,
      required: true,
    },
    intro: {
      type: String,
      required: true,
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true,
    },
    termsandconditionurl: {
      //datalayername="/privacy-policy/privacy-policy"
      type: String,
      required: true,
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true,
    },
    buttontitle: {
      //countertitle="Test message sent"
      type: String,
      default: "submit",
    },
    keepData: {
      //:keep-data="false"
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      postCode: null,
      isLoading: false,
      error: false,
      isShake: false,
      optIns: [],
    };
  },
  methods: {
    save: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var postBody = {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            postcode: this.postCode,
            phone: this.phone != "" ? this.phone : null,
            programName: this.programname,
            cookieID: this.$cookie.get("_mkto_trk"),
            keepData: this.keepData,
            optIns: this.optIns.length > 0 ? this.optIns : "",
          };

          console.log("postBody", postBody);

          this.$store
            .dispatch("saveLead", {
              campaignId: this.datalayername,
              lead: postBody,
            })
            .then(
              (response) => {
                console.log("petition submit success");

                if (window.dataLayer != undefined) {
                  window.dataLayer.push({
                    formName: this.datalayername,
                    event: "formSubmitSuccessEvent",
                  });
                }

                try {
                  //Reset form
                  this.firstName = "";
                  this.lastName = "";
                  this.email = "";
                  this.phone = "";
                  this.postCode = "";
                  this.optIns = [];

                  //Reset errors
                  this.$validator.errors.clear();
                } catch (error) {
                  console.error(error);
                }
              },
              (error) => {
                console.error("Petition submit failed");
              }
            );

          this.$emit("openthankyoucompetitionpopup");
        } else {
          console.log("form invalid");
          // GTM Trackingss
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayername,
              event: "formSubmitEvent",
            });
          }
          this.isShake = true;
          setTimeout(
            function () {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.clear {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// earthhourCompetition.vue?9cf63e68